import React, {Component} from 'react';
import toastr from "toastr";
import _ from 'lodash';
import {getCurrentUserId, getJwt} from '../../../services/authService';
import CampaignDetailsModal from "../../modals/CampaignDetailsModal";
import http from "../../../services/httpService";

import MUIDataTable from "mui-datatables";
import {createTheme, MuiThemeProvider} from '@material-ui/core/styles';
import ChartLoader from '../../utils/chart-loader';

import Theme from "../../../components/common/MuiTheme";

import {paginate} from '../../utils/paginate_posts'

import {Menu, MenuItem, Tag, Spinner, Popover, Position, Icon, Button, Tooltip, Classes} from '@blueprintjs/core';
import ReactGA from "react-ga";
import sizeMe from 'react-sizeme';
import InputRegular from "../../common/InputRegular";
import {Select} from "@blueprintjs/select";
import {DateRangeInput} from "@blueprintjs/datetime";

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class ViberCampaignPerformance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            posts: '',
            totalPosts: '',
            totalPages: '',
            totalCampaigns: 0,
            total_subscribers: 0,
            selectedSource: this.props.selectedSource,
            push_subscribers: [],
            pageSize: 10,
            currentPage: 1,
            lastPage: false,
            lastPageSize: '',
            paging: '',
            selectedAdAccount: '',
            sortColumn: {
                path: "updated_at",
                order: "asc"
            },
            loader: false,
            selectedCampaignPerformance: 'MESSAGES',
            preview: '',
            forceTableRerender: false,
            selectedSubType: '',
            selectedSubTypeFinished: '',
            selectedType: '',
            selectedTypeFinished: '',
            rowHeights: [100, 100, 100, 100, 100],
            tableColumnsWidth: [],
            minTableWidth: 500,
            lastColumnWidth: '',
            campaignDetailsModal: false,

            //modal data

            campaignId: '',
            sendFrom: '',
            sendTime: {
                date: '',
                time: ''
            },
            message: '',
            segments: ['everything'],
            summary: {
                delivered: '',
                deliveredPercentage: '',
                notDelivered: '',
                notDeliveredPercentage: '',
                buffered: '',
                clicked: ''
            },
            sentFrom: '',
            analyticsItem: [],
            analyticsOpen: false,
            user: this.props.user,
            startDate: '',
            endDate: '',
            filterSpent: ''
        }

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }

    openCampaignAnalytics = async (rowData, rowMeta) => {

        // console.log('rowData: ', rowData)
        // console.log('rowMeta: ',)

        const item = this.state.posts[rowMeta.rowIndex]
        //console.log('analytics item: ', item)

        this.setState({
            analyticsItem: item,
            analyticsOpen: true
        })
    }

    getPostsData = async () => {

        try {
            await this.setState({loader: true})
            const pageSize = await this.state.pageSize;
            let selectedSubType = await this.props.selectedSubType;
            let selectedType = await this.props.selectedType;
            let selectedSource = this.props.selectedSource;
            // let selectedSource = '1160';
            // let selectedSource = '1299';


            const result = await http.get('api/user/' + this.props.user.id + '/project/' + selectedSource + '/vib/page_size/' + pageSize + '?page=' + this.state.currentPage, {headers: {authorization: getJwt()}});
            const data = await result.data;
            // console.log('Ojha aloha: ', data)
            //this.props.selectedSubType.name === 'Multiple Custom Links' ? [200,200,200,200,300,300,300,200,200,200] : [100,100,100,100,100,100,100,100,100,100],
            await this.setState({
                selectedSource,
                // rowHeights,
                posts: data.viber_texts.data,
                selectedSubType: selectedSubType.name,
                totalPosts: data.total_viber_s,
                totalPages: data.total_pages,
                lastPage: (data.total_pages < 1) || (this.state.currentPage === data.total_pages) ? true : false,
                lastPageSize: ((data.total_viber_s % this.state.pageSize) === 0) ? data.total_viber_s === 0 ? 0 : this.state.pageSize :
                    ((data.total_viber_s % this.state.pageSize) < 0) ? data.total_viber_s : data.total_viber_s % this.state.pageSize,
                selectedSubTypeFinished: this.props.selectedSubType.name,
                // selectedTypeFinished: this.props.selectedType.name,
                loader: false
            })
            if (!this.state.posts) {
                this.setState({loader: false})
            }
            await this.setState({forceTableRerender: true})
            await this.setState({forceTableRerender: false})
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                this.setState({loader: false})
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    }

    async componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);


        try {
            await this.getPostsData()
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
        //this.getPreview();
    }


    componentDidUpdate = () => {
        if (this.props.selected_source !== this.props.selected_source) {

            this.handlePageChange(1, this.props.selected_source, "all");
        }
        if (this.state.selectedType && this.state.selectedSubType) {
            if ((this.state.selectedSubType !== this.props.selectedSubType.name) && this.state.selectedSubType) {
                this.setState({
                    loader: true,
                    currentPage: 1,
                    selectedSubType: this.props.selectedSubType.name,
                })
                this.getPostsData();
            }

            if (this.state.selectedSource !== this.props.selectedSource) {
                this.setState({
                    loader: true,
                    selectedSource: this.props.selectedSource
                })
                this.getPostsData();
            }


            // this.getPreview();
        }
        if (this.state.selectedSource !== this.props.selectedSource) {
            this.handlePageChange(1, this.props.selectedSource, "all");
            this.getPostsData();
            this.setState({selectedSource: this.props.selectedSource})
        }
    }


    handlePageChange = async (number) => {
        let page = parseInt(number)
        if ((page !== 0) && (page !== this.state.lastPage)) {
            await this.setState({currentPage: page, loader: true});
            this.getPostsData()
        }
    };

    // selectCampaignPerformanceOption = async (selected) =>{
    //     await this.setState({
    //         selectedCampaignPerformance: selected,
    //     })
    //     this.getPostsData()
    // }

    handleChangeCampaignsNumberPerPage = async (value) => {
        await this.setState({
            currentPage: 1,
            pageSize: value,
            lastPage: value > this.state.totalPosts ? true : this.state.lastPage,
            lastPageSize: value > this.state.totalPosts ? this.state.totalPosts : this.state.lastPageSize,
            loader: true
        })

        await this.getPostsData()
    }
    handleDate = (date) => {
        if (this.state.user.locals) {
            let dateFormat = this.state.user.locals.date_format
            let timeFormat = this.state.user.locals.time_format
            // console.log('dateFormat: ', dateFormat)
            // console.log('timeFormat: ', timeFormat)
            // console.log('date: ', date)

            let dateOutput = '';
            let timeOutput = '';
            let dateTimeOutput = '';

            //date formatting according to user settings
            const dateObj = date;
            const month = dateObj.getMonth() < 10 ? '0' + dateObj.getMonth() : dateObj.getMonth();
            const day = String(dateObj.getDate()).padStart(2, '0');
            const year = dateObj.getFullYear();

            switch (dateFormat) {
                case 'DD-MM-YYYY':
                    dateOutput = day + '-' + month + '-' + year;
                    break;
                case 'MM-DD-YYYY':
                    dateOutput = month + '-' + day + '-' + year
                    break;
                case 'YYYY-MM-DD':
                    dateOutput = year + '-' + month + '-' + day
                    break;
            }
            //console.log('dateOutput: ', dateOutput)

            //time formatting according to user settings

            let hours = date.getHours();
            let minutes = date.getMinutes();
            let ampm = hours >= 12 ? 'PM' : 'AM';

            minutes = minutes < 10 ? '0' + minutes : minutes;

            if (timeFormat === 'AM/PM') {
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                timeOutput = hours + ':' + minutes + ampm;
            } else {
                timeOutput = hours + ':' + minutes
            }

            dateTimeOutput = dateOutput + ' ' + timeOutput
            return dateTimeOutput
        } else {
            return date.toLocaleString()
        }

    }
    handleRangeChange = (dateRange) => {
        // console.log('range change: ', dateRange)

        let startDate = dateRange[0]
        // console.log('startDate: ', startDate)
        let endDate = dateRange[1]
        // console.log('endDate: ', endDate)

        this.setState({
            startDate: startDate,
            endDate: endDate
        })
    }
    rerunCampaign = async (e, campaign) => {
        e.stopPropagation()
        this.props.history.push('/new/viber', campaign)
    }
    getPreview = async () => {
        if (!this.state.preview) {
            try {
                const add_account_token = 'EAAZAfK9tK44IBADVZBY4gjXJZBqKdAdCqQokgs5uVNiWm9PtZA7L1qvMF6w2qmNcZCPZAfTfZCCtoxhfW0N3KJZBeRkXLMCfpKuq3SNu3Ybvl9R7JSJU337WcOZB4ZCeO2RyZCLBsBN7j5iDk8GyF2FhUAlbI6C6obOPLB2rCekBNYeGQZDZD';
                const add_account_id = 'act_269773933645768';

                // const adsetId = await campaign.adsets.data[0].id || '';
                // const result = await http.get('https://graph.facebook.com/v4.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative={"type":27, "object_id": 112886416838535}&post={"link":"https://nba.com", "message":"Lorem ipsum dolor sit amet","picture":"http://url.to/your/custom/image.jpg","name":"Facebook","caption":"www.facebook.com","description":"Lorem ipsum dolor sit amet"}')
                const result = await http.get(facebook_app_marketing_url + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                    '&ad_format=MOBILE_FEED_STANDARD&creative={"object_story_spec": {"page_id": "106911734110630", "link_data": { "call_to_action": {"type": "LEARN_MORE", "value": { "link": "https://nba.com" } },"description": "Ovde ide opis", "link": "https://nba.com", "message": "Probna Poruka","name": "Ovde ide ime", "picture": "https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072823__340.jpg" }}}', {headers: {authorization: getJwt()}})

                // Ad formats: DESKTOP_FEED_STANDARD, FACEBOOK_STORY_MOBILE, INSTAGRAM_EXPLORE_CONTEXTUAL, INSTAGRAM_EXPLORE_IMMERSIVE, INSTAGRAM_STANDARD, INSTAGRAM_STORY, INSTANT_ARTICLE_RECIRCULATION_AD, INSTANT_ARTICLE_STANDARD, INSTREAM_VIDEO_DESKTOP, INSTREAM_VIDEO_MOBILE, MESSENGER_MOBILE_INBOX_MEDIA, MESSENGER_MOBILE_STORY_MEDIA, MOBILE_BANNER, MOBILE_FEED_BASIC, MOBILE_FEED_STANDARD, MOBILE_FULLWIDTH, MOBILE_INTERSTITIAL, MOBILE_MEDIUM_RECTANGLE, MOBILE_NATIVE, RIGHT_COLUMN_STANDARD, SUGGESTED_VIDEO_DESKTOP, SUGGESTED_VIDEO_MOBILE, WATCH_FEED_MOBILE"
                // const result = await http.get('https://graph.facebook.com/v5.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative=[{"object_story_spec": "' + object_story_spec + '"}]')


                const iframe = await result.data.data[0].body;
                await this.setState({preview: iframe})
            } catch (e) {
                //console.log('error: ', e)
            }
        }

    }

    checkURL = (url) => {
        return (url.match(/\.(jpeg|jpg|gif|png)$/) != null);
    }

    noViberRenderer = () => {
        return <div className='no-contacts-container panel-container margin-top-20'>
            <img src="/img/emptyStates/url_shortener_my_campaigns.gif"/>
            <h3>Viber Business Profile is not registered or activated.</h3>
            {/*<p>There are no contacts imported, you can add a single contact or import multiple contacts.</p>*/}
            <div className='flex-direction-row justify-content-center'>
                <a href="https://emitto.io/viber-new-sender-name" target='_blank'>
                    <button className=' btn-action margin-bottom-10'>
                        Request Viber Business Profile
                    </button>
                </a>
            </div>
        </div>
    };

    noViberPostsRenderer = () => {
        return <div className='no-contacts-container panel-container margin-top-20'>
            <img src="/img/emptyStates/url_shortener_my_campaigns.gif"/>
            <h3>There is no data for this type of messages.</h3>
            {/*<p>There are no contacts imported, you can add a single contact or import multiple contacts.</p>*/}
            <div className='flex-direction-row justify-content-center'>
                <button className=' btn-action margin-bottom-10' onClick={() => this.props.history.push('/new/viber')}>
                    Start a Viber Campaign
                </button>
            </div>
        </div>
    };

    tableLoaderRenderer = () => {
        return <div className='table-loader-container'>
            <ChartLoader/>
        </div>
    }
    closeAnalytics = async () => {
        this.setState({
            analyticsOpen: false
        })
    }


    getMuiTheme = () => createTheme(Theme)

    render() {
        const {
            pageSize,
            currentPage,
            sortColumn,
            searchQuery,
            sub_type,
            type_of_subscription,
            total_subscribers
        } = this.state;
        let {
            subscribers: subscribersAll,
            //push_subscribers: subscribersPush
        } = this.state;
        const totalSent = process.env.REACT_APP_ENVIRONMENT === 'DEV' ? this.state.analyticsItem.total_count : this.state.analyticsItem.sent_count
        const sentCount = this.state.analyticsItem.sent_count
        //console.log('totalSent: ', totalSent)
        const delivered = this.state.analyticsItem.delivered_count
        //console.log('delivered: ', delivered)
        const buffered = this.state.analyticsItem.buffered_count
        //console.log('buffered: ', buffered)

        let bufferedPercentage = buffered === 0 ? '(0%)' :
            (this.state.analyticsItem.buffered_count / this.state.analyticsItem.sent_count * 100) % 1 === 0 ?
                //'(' +
                (this.state.analyticsItem.buffered_count / this.state.analyticsItem.sent_count * 100)
                //+ '%)'
                :
                //'(' +
                Math.round(this.state.analyticsItem.buffered_count /
                    this.state.analyticsItem.sent_count * 100).toFixed(2)
        //+ '%)'

        if (bufferedPercentage !== '(0%)') {

            if (bufferedPercentage % 1 === 0) {
                bufferedPercentage = '(' + Number(bufferedPercentage).toFixed(0) + '%)'
            } else {
                bufferedPercentage = '(' + Number(bufferedPercentage) + '%)'
            }
        }


        let deliveredPercentage = delivered === 0 ? '(0%)' :
            (this.state.analyticsItem.delivered_count / this.state.analyticsItem.sent_count * 100) % 1 === 0 ?

                //'(' +
                this.state.analyticsItem.delivered_count / this.state.analyticsItem.sent_count * 100
                //+ '%)'
                :
                //'(' +
                Math.round(this.state.analyticsItem.delivered_count /
                    this.state.analyticsItem.sent_count * 100).toFixed(2)
        //+ '%)'
        if (deliveredPercentage !== '(0%)') {
            if (deliveredPercentage % 1 === 0) {
                deliveredPercentage = '(' + Number(deliveredPercentage).toFixed(0) + '%)'
            } else {
                deliveredPercentage = '(' + Number(deliveredPercentage) + '%)'
            }
        }
        const notDelivered = this.state.analyticsItem.undelivered_count

        //this.state.analyticsItem.undelivered_count
        let notDeliveredPercentage = notDelivered === 0 ? '(0%)' :
            this.state.analyticsItem.undelivered_count / this.state.analyticsItem.sent_count * 100 % 1 === 0 ?
                //'(' +
                (this.state.analyticsItem.undelivered_count / this.state.analyticsItem.sent_count * 100)
                //+ '%)'
                :
                //'(' +
                Math.round((this.state.analyticsItem.undelivered_count) /
                    this.state.analyticsItem.sent_count * 100).toFixed(2)
        //+ '%)'
        if (notDeliveredPercentage !== '(0%)') {
            if (notDeliveredPercentage % 1 === 0) {
                notDeliveredPercentage = '(' + Number(notDeliveredPercentage).toFixed(0) + '%)'
            } else {
                notDeliveredPercentage = '(' + Number(notDeliveredPercentage) + '%)'
            }
        }

        const read = this.state.analyticsItem.read_count
        //console.log('read count: ', read)


        let readPercentage = read === 0 ? '(0%)' :
            this.state.analyticsItem.read_count / this.state.analyticsItem.delivered_count * 100 % 1 === 0 ?
                //'(' +
                (this.state.analyticsItem.read_count / this.state.analyticsItem.delivered_count * 100)
                //+ '%)'
                :
                //'(' +
                Math.round((this.state.analyticsItem.read_count) /
                    this.state.analyticsItem.delivered_count * 100).toFixed(2)
        //+ '%)'
        if (readPercentage !== '(0%)') {
            if (readPercentage % 1 === 0) {
                readPercentage = '(' + Number(readPercentage).toFixed(0) + '%)'
            } else {
                readPercentage = '(' + Number(readPercentage) + '%)'
            }
        }

        // console.log('readPercentage: ', readPercentage)

        let filtered = subscribersAll;
        if (searchQuery) {
            if (sub_type) {
                filtered = subscribersAll.filter(m => m.subscriber_name.toLowerCase().includes(searchQuery.toLowerCase()));
            }
        }
        const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
        const campaigns = paginate(sorted, currentPage, pageSize);


        const columns = [
            // {
            //     name: "type",
            //     label: " ",
            //     options: {
            //         filter: false,
            //         sort: true,
            //         customBodyRender: (value, tableMeta, updateValue) => {=-
            //             const item = tableMeta.tableData[tableMeta.rowIndex];
            //             return <i onClick={() => this.openModal(tableMeta.rowIndex)}
            //                       className={item.type === 'custom_single' ? 'fas fa-eye type-icon' : 'fas fa-eye type-icon'}></i>
            //         }
            //     }
            // },
            {
                name: "sent",
                label: " Sent ",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div className='sent-cell-container'>
                            <i className="fas fa-paper-plane type-icon" style={{marginBottom: 5, marginLeft: 0}}></i>
                            <span className='text-bold blue-text'>
                                {process.env.REACT_APP_ENVIRONMENT === 'DEV' ? item.total_count : item.sent_count}
                            </span>
                        </div>
                    }
                }
            },
            {
                name: "delivered",
                label: "Delivered",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div style={{minWidth: 80}}>
                            <img style={{marginRight: 5}} src='/img/double-tick-indicator.png' alt='double tick'/>
                            {item.delivered_count}
                        </div>
                    }
                }
            },
            {
                name: "delivered_percentage",
                label: "%",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div className='text-light-grey'>
                            {item.sent_count ? (parseInt(item.delivered_count) / parseInt(item.sent_count) * 100) % 1 === 0 ? (parseInt(item.delivered_count) / parseInt(item.sent_count) * 100) : Math.round(Number((parseInt(item.delivered_count) / parseInt(item.sent_count) * 100).toFixed(2))) : 0}%
                        </div>
                    }
                }
            },
            // {
            //     name: "clicked",
            //     label: "Clicked",
            //     options: {
            //         filter: false,
            //         sort: false,
            //         customBodyRender: (value, tableMeta, updateValue) => {
            //             const item = tableMeta.tableData[tableMeta.rowIndex];
            //             return <div className="text-light-blue">
            //                 <i className="fas fa-envelope-open" style={{color: '#18A9E3'}}></i> {item.read_count}</div>
            //         }
            //     }
            // },
            // {
            //     name: "clicked_percentage",
            //     label: "%",
            //     options: {
            //         filter: false,
            //         sort: true,
            //         customBodyRender: (value, tableMeta, updateValue) => {
            //             const item = tableMeta.tableData[tableMeta.rowIndex];
            //             return <div className='text-light-grey'>
            //                 {item.sent_count && item.read_count ? ((parseInt(item.read_count) / parseInt(item.sent_count) * 100) + '%') : '0%'}
            //             </div>
            //         }
            //     }
            // },
            {
                name: "spent",
                label: "Spent",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div>
                            {item.spent ?
                                !value.includes('$') ?
                                    Number(item.spent.replace('$', '')).toFixed(2)
                                    :
                                    '$' + Number(item.spent.replace('$', '')).toFixed(2)
                                : '0.00'}
                        </div>
                    }
                }
            },
            {
                name: "image",
                label: "Image",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        let image = '';
                        if (item.message && item.message.components && item.message.components.length) {
                            item.message.components.map(component => component.type === 'image' ? image = component.image.url : '')
                        }

                        let isImage = image ? this.checkURL(image) : false
                        return (
                            image ?
                                <div className='image-cell'>
                                    {

                                        isImage ?
                                            <img className='viber-image' alt='viber-image' src={image}/>
                                            :
                                            ''
                                    }
                                </div>
                                :
                                <div className='image-cell'>
                                </div>
                        )
                    }
                }
            },
            {
                name: "message",
                label: "Message",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        let message = '';
                        if (item.message && item.message.components && item.message.components.length) {
                            item.message.components.map(component => component.type === 'text' ? message = component.text : '')
                        }
                        return <div className='mui-column-wrapper'>{message}</div>
                    }
                }
            },
            {
                name: "link",
                label: "Link",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        let link = '';
                        if (item.message && item.message.components && item.message.components.length) {
                            item.message.components.map(component => component.type === 'button' ?
                                link = component.button ? component.button.callback ? component.button.callback : '' : '' : '')
                        }
                        return <div className='mui-column-wrapper'>
                            {link !== '' ?
                                <a href={link} target="_blank"><i className="fas fa-link type-icon"></i></a>
                                :
                                <div/>
                            }
                        </div>
                    }
                }
            },
            {
                name: "segments",
                label: "Segments",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div>
                            {
                                item.tags && item.tags.length ?

                                    item.tags.map(tag =>
                                        <Tag
                                            className={['custom-tag', tag.toLowerCase() === 'immediate' ? 'bp3-intent-primary' : tag.toLowerCase() === 'daily' ?
                                                'bp3-intent-success' : tag.toLowerCase() === 'weekly' ? 'bp3-intent-warning' :
                                                    tag.toLowerCase() === 'weekly' ? 'bp3-intent-darkblue' : '']}
                                            key={tag}
                                        >
                                            {tag.toLowerCase()}
                                        </Tag>
                                    )
                                    : <Tag className='custom-tag'>everyone</Tag>
                            }
                            {
                                item.tags && item.tags.length > 3 ?
                                    <Popover
                                        content={
                                            <div className='popover-tags padding-10'>
                                                {item.tags.map(tag =>
                                                    <Tag
                                                        className={['custom-tag', tag.toLowerCase() === 'immediate' ? 'bp3-intent-primary' : tag.toLowerCase() === 'daily' ?
                                                            'bp3-intent-success' : tag.toLowerCase() === 'weekly' ? 'bp3-intent-warning' :
                                                                tag.toLowerCase() === 'weekly' ? 'bp3-intent-darkblue' : '']}
                                                        key={tag}
                                                    >
                                                        {tag.toLowerCase()}
                                                    </Tag>
                                                )}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Cao</Tag>*/}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Zdravo jos ne</Tag>*/}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Cao</Tag>*/}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Zdravo</Tag>*/}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Cao cao</Tag>*/}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Cao cao</Tag>*/}
                                            </div>
                                        }
                                        className={'bp3-popover-segments'}
                                        position={Position.LEFT}
                                    >

                                    </Popover>
                                    :
                                    ''
                            }
                        </div>
                    }
                }
            },
            {
                name: "sent_at",
                label: "Sent at",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        let dateConverted = item.sent_at ? this.props.isodateToDate(item.sent_at) : ''
                        let date = dateConverted ? dateConverted.substr(0, dateConverted.indexOf(' ')) : 'No date';
                        let time = dateConverted ? dateConverted.substr(dateConverted.indexOf(' ') + 1) : 'No time';
                        return <div className='mui-column-wrapper min-width-80'>
                            <p style={{marginBottom: 5}}>{date}</p>
                            <p style={{color: 'rgb(164, 175, 183)'}}>{time}</p>
                        </div>
                    }
                }
            },
            {
                name: "sent_at_timezone",
                label: "Actions",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];

                        //console.info('item: ', item)
                        return (

                            <div className='text-center'>

                                <Tooltip
                                    position={Position.TOP}
                                    className={Classes.TOOLTIP_INDICATOR}
                                    content={<span>Create new campaign with the same data</span>}
                                    isOpen={this.state.isOpen}
                                >
                                    <Icon className='rerun-icon' onClick={(e) => this.rerunCampaign(e, item)}
                                          icon='duplicate'/>
                                </Tooltip>
                            </div>
                        )

                    }
                }
            },
        ];

        const options = {
            serverSide: true,
            count: this.state.totalPosts,
            selectableRows: 'none',
            rowsPerPage: this.state.pageSize,
            viewColumns: false,
            download: false,
            print: false,
            search: false,
            filter: false,
            sort: false,
            onRowClick: this.openCampaignAnalytics,
            onChangeRowsPerPage: (number) => this.handleChangeCampaignsNumberPerPage(number),
            page: this.state.currentPage - 1,
            rowsPerPageOptions: [10, 25, 50, 100],
            rowsSelected: this.state.rowsSelected,
            textLabels: {
                body: {
                    noMatch: this.state.loader ?
                        this.tableLoaderRenderer()
                        :
                        'Sorry, there is no matching data to display',
                },
            },
            onTableChange: (action, tableState) => {
                // console.log(action, tableState);

                // a developer could react to change on an action basis or
                // examine the state as a whole and do whatever they want

                switch (action) {
                    case 'changePage':
                        this.handlePageChange(tableState.page + 1);
                        break;
                    case 'sort':
                        this.handleSortContacts(tableState.sortOrder)
                        break;
                    // default:
                    //     console.log('action not handled.');
                }
            },
            onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
                this.setState({rowsSelected});
                this.handleCheck(rowsSelected)
                //console.log('currentRowsSelected: ', currentRowsSelected, ' allRowsSelected:', allRowsSelected, ' rowsSelected:', rowsSelected)
            }

        };

        return (
            <React.Fragment>
                <div className="d-block">
                    {/*{ this.state.preview ? <div dangerouslySetInnerHTML={{ __html: this.state.preview }} /> : null }*/}
                    <div className='margin-bottom-10'>
                    </div>
                    {
                        this.state.loader ?
                            this.tableLoaderRenderer()
                            :
                            !this.state.posts || (this.props.selectedSubType.name === 'Scheduled') || (this.state.posts && this.state.posts.length < 1) && !this.state.loader ?
                                this.props.selectedSourceNode.viber_client ?
                                    this.noViberPostsRenderer()
                                    :
                                    this.noViberRenderer()
                                :

                                this.state.analyticsOpen ?
                                    //'asd'
                                    <React.Fragment>
                                        <div className='sms-analytics-container'>

                                            <div className="analytics-title">
                                                <span onClick={this.closeAnalytics}>{'< Campaign Details'}</span>
                                            </div>
                                            <div className="sms-analytics-main">
                                                <div className="top-part-container">
                                                    <div className="top-part-info">
                                                        <div className='display-fle``x'>
                                                            <p className='text-semi-bold'>Spent</p>
                                                            <p>{

                                                                !this.state.analyticsItem.spent.includes('$') ?
                                                                    Number(this.state.analyticsItem.spent.replace('$', '')).toFixed(2)
                                                                    :
                                                                    '$' + Number(this.state.analyticsItem.spent.replace('$', '')).toFixed(2)
                                                            }
                                                            </p>
                                                        </div>
                                                        <div className='display-flex'>
                                                            <p className='text-semi-bold'>Sender</p>
                                                            <p>{this.state.analyticsItem.from}</p>
                                                        </div>
                                                        <div className='display-flex'>
                                                            <p className='text-semi-bold'>Created at</p>
                                                            <p>{this.props.isodateToDate(this.state.analyticsItem.sent_at)}</p>
                                                        </div>
                                                    </div>
                                                    <div id='message'>

                                                        <p className='message-text'>


                                                            <div className='message-button-container'>
                                                                {
                                                                    this.state.analyticsItem.message && this.state.analyticsItem.message.components && this.state.analyticsItem.message.components.length ?
                                                                        this.state.analyticsItem.message.components.map(component => component.type === 'text' ?
                                                                            <p key={component.text}
                                                                               className='message-text-container'>
                                                                                <span
                                                                                    className='text-semi-bold'>Message</span>
                                                                                {
                                                                                    component.text
                                                                                }
                                                                            </p>
                                                                            :
                                                                            '')
                                                                        : ''
                                                                }
                                                                {this.state.analyticsItem.message && this.state.analyticsItem.message.components && this.state.analyticsItem.message.components.length ?
                                                                    this.state.analyticsItem.message.components.map(component => component.type === 'button' ?
                                                                        <dev key={component.button.caption}>
                                                                            <p><span className='text-semi-bold'>Button
                                                                                Text</span> {component.button.caption}
                                                                            </p>
                                                                            <p><span className='text-semi-bold'>Button
                                                                                Link</span> <a
                                                                                href={component.button.callback}>{component.button.callback}</a>
                                                                            </p>
                                                                        </dev>
                                                                        :
                                                                        '')
                                                                    : ''

                                                                }
                                                            </div>
                                                            {this.state.analyticsItem.message && this.state.analyticsItem.message.components && this.state.analyticsItem.message.components.length ?
                                                                this.state.analyticsItem.message.components.map(component => component.type === 'image' ?

                                                                    <img
                                                                        src={component.image.url}
                                                                        alt="message-image"/>
                                                                    :
                                                                    '') :
                                                                ''
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className='display-flex align-items-center'>
                                                    <p className='text-semi-bold'>Segments</p>
                                                    <p>
                                                        {this.state.analyticsItem.tags ?
                                                            this.state.analyticsItem.tags.map(tag =>
                                                                <Tag
                                                                    className={['custom-tag', tag.toLowerCase() === 'immediate' ? 'bp3-intent-primary' : tag.toLowerCase() === 'daily' ?
                                                                        'bp3-intent-success' : tag.toLowerCase() === 'weekly' ? 'bp3-intent-warning' :
                                                                            tag.toLowerCase() === 'weekly' ? 'bp3-intent-darkblue' : '']}
                                                                    key={tag}
                                                                >
                                                                    {tag}
                                                                </Tag>
                                                            ) : ''
                                                        }
                                                    </p>
                                                </div>
                                                <div className='display-flex align-items-center'>
                                                    <p className='text-semi-bold'>Summary</p>

                                                    {process.env.REACT_APP_ENVIRONMENT === 'DEV' ?
                                                        <p className='display-flex justify-content-start summary-data'>

                                                            <p id='total' className='summary-segment'>
                                                                <i className="fas fa-paper-plane"></i>
                                                                <span className='summary-label'>Total:</span>

                                                                <span className='segment-number'>
                                                                {totalSent}
                                                            </span>
                                                            </p>
                                                            <p id='total' className='summary-segment'>
                                                                <i className="fas fa-paper-plane"></i>
                                                                <span className='summary-label'>Sent:</span>

                                                                <span className='segment-number'>
                                                                {sentCount}
                                                            </span>
                                                            </p>
                                                            <div className='display-flex campaign-info'>
                                                                <p id='delivered' className='summary-segment'>
                                                                    <img src="/img/double-tick-indicator.png"
                                                                         alt="Delivered"/>
                                                                    <span className='summary-label'>Delivered:</span>

                                                                    <span className='segment-number'>{delivered}<span
                                                                        className='grey-text'> {deliveredPercentage}</span>
                                                                </span>
                                                                </p>

                                                                <p id='not-delivered' className='summary-segment'>
                                                                    <img src="/img/material-close.png"
                                                                         alt="Not delivered"/>
                                                                    <span
                                                                        className='summary-label'>Not Delivered:</span>
                                                                    <span
                                                                        className='segment-number'>{notDelivered < 0 ? 0 : notDelivered}<span
                                                                        className='grey-text'> {notDelivered < 0 ? '0%' : notDeliveredPercentage}</span>
                                                                </span>
                                                                </p>

                                                                <p id='buffered' className='summary-segment'>
                                                                    <img src="/img/feather-loader.png" alt="Buffered"/>

                                                                    <span className='summary-label'>Buffered:</span>
                                                                    <span className='segment-number'>{buffered}<span
                                                                        className='grey-text'> {bufferedPercentage}</span></span>
                                                                </p>
                                                                <p id='read' className='summary-segment'>
                                                                    <i className="far fa-eye"></i>
                                                                    <span className='summary-label'>Read:</span>
                                                                    <span className='segment-number'>{read}<span
                                                                        className='grey-text'> {readPercentage}</span></span>
                                                                </p>
                                                            </div>
                                                            {/*<p id='clicked' className='summary-segment'>*/}
                                                            {/*    <img src="/img/click.png" alt="Clicked"/>*/}

                                                            {/*    <span className='summary-label'>Clicked:</span>*/}
                                                            {/*    <span>{clicked}<span*/}
                                                            {/*        className='grey-text'> {clickedPercentage}</span></span>*/}
                                                            {/*</p>*/}

                                                        </p>
                                                        :

                                                        <p className='display-flex justify-content-start summary-data'>

                                                            <p id='total' className='summary-segment'>
                                                                <i className="fas fa-paper-plane"></i>
                                                                <span className='summary-label'>Total:</span>

                                                                <span className='segment-number'>
                                                                {totalSent}
                                                            </span>
                                                            </p>
                                                            <div className='display-flex campaign-info'>
                                                                <p id='delivered' className='summary-segment'>
                                                                    <img src="/img/double-tick-indicator.png"
                                                                         alt="Delivered"/>
                                                                    <span className='summary-label'>Delivered:</span>

                                                                    <span className='segment-number'>{delivered}<span
                                                                        className='grey-text'> {deliveredPercentage}</span>
                                                                </span>
                                                                </p>

                                                                <p id='not-delivered' className='summary-segment'>
                                                                    <img src="/img/material-close.png"
                                                                         alt="Not delivered"/>
                                                                    <span
                                                                        className='summary-label'>Not Delivered:</span>
                                                                    <span
                                                                        className='segment-number'>{notDelivered < 0 ? 0 : notDelivered}<span
                                                                        className='grey-text'> {notDelivered < 0 ? '0%' : notDeliveredPercentage}</span>
                                                                </span>
                                                                </p>

                                                                <p id='buffered' className='summary-segment'>
                                                                    <img src="/img/feather-loader.png" alt="Buffered"/>

                                                                    <span className='summary-label'>Buffered:</span>
                                                                    <span className='segment-number'>{buffered}<span
                                                                        className='grey-text'> {bufferedPercentage}</span></span>
                                                                </p>
                                                                <p id='read' className='summary-segment'>
                                                                    <i className="far fa-eye"></i>
                                                                    <span className='summary-label'>Read:</span>
                                                                    <span className='segment-number'>{read}<span
                                                                        className='grey-text'> {readPercentage}</span></span>
                                                                </p>
                                                            </div>
                                                            {/*<p id='clicked' className='summary-segment'>*/}
                                                            {/*    <img src="/img/click.png" alt="Clicked"/>*/}

                                                            {/*    <span className='summary-label'>Clicked:</span>*/}
                                                            {/*    <span>{clicked}<span*/}
                                                            {/*        className='grey-text'> {clickedPercentage}</span></span>*/}
                                                            {/*</p>*/}

                                                        </p>
                                                    }
                                                </div>
                                            </div>

                                            {/*{process.env.REACT_APP_ENVIRONMENT === 'DEV' ?*/}
                                            {/*    <React.Fragment>*/}
                                            {/*        <div className="filtering-row display-flex flex-wrap">*/}
                                            {/*            <div className="filter-input">*/}
                                            {/*                <InputRegular*/}
                                            {/*                    id="1"*/}
                                            {/*                    label1="Recipient"*/}
                                            {/*                    label2=""*/}
                                            {/*                    placeholder="Enter number"*/}
                                            {/*                    type='text'*/}
                                            {/*                    onChange={p => this.setState({*/}
                                            {/*                        filterRecipient: p*/}
                                            {/*                    })}*/}
                                            {/*                    value={this.state.filterRecipient}*/}
                                            {/*                    // updateErrorsList={this.updateErrorsList}*/}
                                            {/*                    // errorMessage="Check your password"*/}
                                            {/*                    //fieldsCheckActive={this.state.fieldsCheckActive}*/}
                                            {/*                    required={false}*/}
                                            {/*                />*/}
                                            {/*            </div>*/}
                                            {/*            <div id='select-status' className="filter-input">*/}
                                            {/*                <label>Status</label>*/}
                                            {/*                <Select*/}
                                            {/*                    items={this.state.statusValues}*/}
                                            {/*                    itemRenderer={this.statusItemRenderer}*/}
                                            {/*                    onItemSelect={this.statusItemSelect}*/}
                                            {/*                    filterable={false}*/}
                                            {/*                >*/}
                                            {/*                    <Button text={this.state.filterStatus}></Button>*/}

                                            {/*                </Select>*/}
                                            {/*            </div>*/}
                                            {/*            <div id='spentFilterInput' className="filter-input">*/}
                                            {/*                <span>$</span>*/}
                                            {/*                <InputRegular*/}
                                            {/*                    id="3"*/}
                                            {/*                    label1="Spent"*/}
                                            {/*                    label2=""*/}
                                            {/*                    placeholder="0.00"*/}
                                            {/*                    type='number'*/}
                                            {/*                    step='0.01'*/}
                                            {/*                    onChange={p => {*/}
                                            {/*                        //p = p.substring(2)*/}
                                            {/*                        //p = p.toFixed(2)*/}
                                            {/*                        this.setState({*/}
                                            {/*                            filterSpent: p*/}
                                            {/*                        })*/}
                                            {/*                    }}*/}
                                            {/*                    value={Number(this.state.filterSpent)}*/}
                                            {/*                    // updateErrorsList={this.updateErrorsList}*/}
                                            {/*                    // errorMessage="Check your password"*/}
                                            {/*                    //fieldsCheckActive={this.state.fieldsCheckActive}*/}
                                            {/*                    required={false}*/}
                                            {/*                />*/}
                                            {/*            </div>*/}
                                            {/*            <div id='datepicker' className="filter-input">*/}
                                            {/*                <label>Timestamp</label>*/}
                                            {/*                <DateRangeInput*/}
                                            {/*                    formatDate={date => this.handleDate(date)}*/}
                                            {/*                    onChange={this.handleRangeChange}*/}
                                            {/*                    parseDate={str => new Date(str)}*/}
                                            {/*                    value={[this.state.startDate, this.state.endDate]}*/}
                                            {/*                    allowSingleDayRange={true}*/}
                                            {/*                    timePickerProps={*/}
                                            {/*                        {*/}
                                            {/*                            autoFocus: true*/}
                                            {/*                        }*/}
                                            {/*                    }*/}
                                            {/*                />*/}
                                            {/*            </div>*/}
                                            {/*            <button className='btn-action'*/}
                                            {/*                    onClick={this.applyFilter}*/}
                                            {/*            >*/}
                                            {/*                Apply Filter*/}
                                            {/*            </button>*/}
                                            {/*        </div>*/}
                                            {/*        /!*<MuiThemeProvider theme={this.getMuiTheme()}>*!/*/}
                                            {/*        /!*    <MUIDataTable*!/*/}
                                            {/*        /!*        title={""}*!/*/}
                                            {/*        /!*        data={this.state.recipients}*!/*/}
                                            {/*        /!*        columns={recipientTableColumns}*!/*/}
                                            {/*        /!*        options={recipientTableOptions}*!/*/}
                                            {/*        /!*    />*!/*/}
                                            {/*        /!*</MuiThemeProvider>*!/*/}
                                            {/*    </React.Fragment>*/}
                                            {/*    :*/}
                                            {/*    ''*/}
                                            {/*}*/}
                                        </div>


                                    </React.Fragment>
                                    :
                                    <MuiThemeProvider theme={this.getMuiTheme()}>
                                        <MUIDataTable
                                            title={""}
                                            data={this.state.posts}
                                            columns={columns}
                                            options={options}
                                        />
                                    </MuiThemeProvider>
                    }

                </div>
                {/*{ console.log(this.state.currentPage, this.state.totalPosts, this.state.totalPages, this.state.lastPageSize, this.state.lastPage)}*/}
                <CampaignDetailsModal
                    showModal={this.state.campaignDetailsModal}
                    handleClose={() => this.setState({campaignDetailsModal: false})}
                    maxWidth={540}
                    history={this.props.history}
                    campaignId={this.state.campaignId}
                    sendFrom={this.state.sendFrom}
                    sendTime={this.state.sendTime}
                    message={this.state.message}
                    segments={this.state.segments}
                    summary={this.state.summary}
                    sentFrom={this.state.sentFrom}
                />
            </React.Fragment>
        )
    }
}

export default sizeMe()(ViberCampaignPerformance);